import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

export interface ParentLinkedStudent {
  studentId: number;
  studentName: string;
  grade: string;
  phone: string;
}

interface ParentStudentState {
  /** GET /api/parents/my-students 응답 — 연결된 자녀 목록 */
  students: ParentLinkedStudent[];
  /** 현재 화면에서 보고 있는 자녀. 미선택이면 null. id만이 아니라 이름·학년 등 전체 정보를 들고 있어
   *  화면에서 다시 목록을 뒤져 찾을 필요 없이 바로 쓸 수 있다 */
  selectedStudent: ParentLinkedStudent | null;
  setStudents: (students: ParentLinkedStudent[]) => void;
  selectStudent: (student: ParentLinkedStudent) => void;
  reset: () => void;
}

/**
 * 학부모가 화면(앱 스타일 My Class/Attendance)에서 보고 있는 자녀(학생) 컨텍스트.
 * authStore(로그인한 '학부모 본인' 정보)와는 별개로, 학부모가 여러 자녀 중 누구를 보고 있는지를 들고 있다.
 * 로그아웃 시 authStore와 함께 reset() 해줘야 한다.
 */
export const useParentStudentStore = create<ParentStudentState>()(
  persist(
    (set) => ({
      students: [],
      selectedStudent: null,
      setStudents: (students) => set({ students }),
      selectStudent: (student) => set({ selectedStudent: student }),
      reset: () => set({ students: [], selectedStudent: null }),
    }),
    {
      name: 'ParentStudentStore',
      storage: createJSONStorage(() => localStorage),
    }
  )
);
